/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ApiResponseDTOBeneficiaryDetailsRecord } from "../models/ApiResponseDTOBeneficiaryDetailsRecord";
import type { ApiResponseDTOBeneficiaryNameRecord } from "../models/ApiResponseDTOBeneficiaryNameRecord";
import type { ApiResponseDTOBeneficiaryRecord } from "../models/ApiResponseDTOBeneficiaryRecord";
import type { ApiResponseDTOVoid } from "../models/ApiResponseDTOVoid";
import type { BeneficiaryDetailsRecord } from "../models/BeneficiaryDetailsRecord";

import type { CancelablePromise } from "../core/CancelablePromise";
import { OpenAPI } from "../core/OpenAPI";
import { request as __request } from "../core/request";

export class BeneficiaryApiService {
  /**
   * Finds Beneficiaries
   * Retrieves a paginated list of beneficiaries that fulfill the selection parameters.
   * @param bankId
   * @param external
   * @returns ApiResponseDTOBeneficiaryRecord OK
   * @throws ApiError
   */
  public static getBeneficiary(
    bankId?: string,
    external: boolean = false
  ): CancelablePromise<ApiResponseDTOBeneficiaryRecord> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/beneficiary",
      query: {
        bankId: bankId,
        external: external,
      },
      errors: {
        404: `Not Found`,
        422: `Unprocessable Entity`,
        501: `Not Implemented`,
      },
    });
  }

  /**
   * Create Beneficiary
   * Create a beneficiary with its details
   * @param requestBody
   * @returns ApiResponseDTOBeneficiaryDetailsRecord Created
   * @throws ApiError
   */
  public static postBeneficiary(
    requestBody: BeneficiaryDetailsRecord
  ): CancelablePromise<ApiResponseDTOBeneficiaryDetailsRecord> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/beneficiary",
      body: requestBody,
      mediaType: "application/json",
      errors: {
        404: `Not Found`,
        422: `Unprocessable Entity`,
        501: `Not Implemented`,
      },
    });
  }

  /**
   * Get the name of the Beneficiary from the Bank
   * Retrieves the name of the bank beneficiary.
   * @param accountNumber
   * @param bankId
   * @returns ApiResponseDTOBeneficiaryNameRecord OK
   * @throws ApiError
   */
  public static getBankBeneficiary(
    accountNumber: string,
    bankId: string
  ): CancelablePromise<ApiResponseDTOBeneficiaryNameRecord> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/beneficiary/{bankId}/beneficiary",
      path: {
        bankId: bankId,
      },
      headers: {
        accountNumber: accountNumber,
      },
      errors: {
        404: `Not Found`,
        422: `Unprocessable Entity`,
        501: `Not Implemented`,
      },
    });
  }

  /**
   * Delete Beneficiary
   * Delete a beneficiary
   * @param id
   * @returns ApiResponseDTOVoid OK
   * @throws ApiError
   */
  public static deleteBeneficiaryById(
    id: string
  ): CancelablePromise<ApiResponseDTOVoid> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/beneficiary/{id}",
      path: {
        id: id,
      },
      errors: {
        404: `Not Found`,
        422: `Unprocessable Entity`,
        501: `Not Implemented`,
      },
    });
  }

  /**
   * Find Beneficiary by ID
   * Retrieves the Beneficiary detail
   * @param id
   * @returns ApiResponseDTOBeneficiaryDetailsRecord OK
   * @throws ApiError
   */
  public static getBeneficiaryById(
    id: string
  ): CancelablePromise<ApiResponseDTOBeneficiaryDetailsRecord> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/beneficiary/{id}",
      path: {
        id: id,
      },
      errors: {
        404: `Not Found`,
        422: `Unprocessable Entity`,
        501: `Not Implemented`,
      },
    });
  }

  /**
   * Edit Beneficiary
   * Edit a beneficiary with its details
   * @param id
   * @param requestBody
   * @returns ApiResponseDTOBeneficiaryDetailsRecord OK
   * @throws ApiError
   */
  public static putBeneficiary(
    id: string,
    requestBody: BeneficiaryDetailsRecord
  ): CancelablePromise<ApiResponseDTOBeneficiaryDetailsRecord> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/beneficiary/{id}",
      path: {
        id: id,
      },
      body: requestBody,
      mediaType: "application/json",
      errors: {
        404: `Not Found`,
        422: `Unprocessable Entity`,
        501: `Not Implemented`,
      },
    });
  }
}
